import { render, staticRenderFns } from "./PreviewDetail.vue?vue&type=template&id=c202514c&scoped=true&"
import script from "./PreviewDetail.vue?vue&type=script&lang=js&"
export * from "./PreviewDetail.vue?vue&type=script&lang=js&"
import style0 from "./PreviewDetail.vue?vue&type=style&index=0&id=c202514c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c202514c",
  null
  
)

export default component.exports